import React, {useEffect, useState} from 'react';
import {Paper, TextField, Typography} from '@mui/material';

export const ImageMutated = ({event, chatContainerRef}) => {
    const [data, setData] = useState([event]);

    // useEffect(() => {
    //     setTimeout(() => {
    //         chatContainerRef.current.scrollTo(0, chatContainerRef.current.scrollHeight + 1000);
    //         // Todo to resend the rotated image
    //     }, 1500)
    //
    // }, [event]);

    return (
            <Paper style={{width: '100%'}} sx={{p: 2, mb: 2}} key={1}>
                <TextField
                    multiline={true}
                    fullWidth
                    disabled={true}
                    value={event.message}
                    size="small"
                    inputProps={{ }}
                />
            </Paper>
    )
};
